import { CamelCaseKeys } from '@utils/typescript';
import { tEnum } from '@components/i18n';
import { ClaimStatuses } from '@models/Claim';
import { PaymentInfo } from '@models/PaymentInfo';

export enum CorporateHealthClaimTypes {
  IpdHospitalAndSurgicalBenefits = 'ipd_hospital_and_surgical_benefits',
  OpdBenefits = 'opd_benefits',
  HealthCheckupBenefits = 'health_checkup_benefits',
  DentalBenefits = 'dental_benefits',
  MaternityBenefits = 'maternity_benefits',
  VisionBenefits = 'vision_benefits',
  CopayBenefits = 'copay_benefits',
  OtherBenefits = 'other_benefits',
  GeneralPersonalAccidentBenefits = 'general_personal_accident_benefits',
}

export type CorporateHealthClaim = CamelCaseKeys<{
  id: number;
  status: ClaimStatuses;
  accident_happened_at: string;
  claim_type: string;
  supporting_documents: string[];
  additional_documents: string[];
  total_claimed_amount: number;
  approved_amount: number;
  note: string;
  claim_number: string;
  payment_info: PaymentInfo;
  billing_type_code: string;
}>;

export const getCorporateHealthClaimType = (type: CorporateHealthClaimTypes) =>
  tEnum('healthPlanBenefitTypes', type);
